import React, { useState, useEffect } from "react";

import Footer from "../../molecules/footer/footer";
import Header from "../../molecules/header/header";
import Headboard from "../headboard/headboard";
import Nav from "../nav/nav";

import GlobalContext from "../../../contexts/globalContext";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";

import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import useDirectionScroll from "../../../shared/hooks/useDirectionScroll";

import "./layout.scss";
import { setCollectionToken } from "../../../services/token";
import HeadboardTwo from "../headboard-two/headboard-two";
import CategoryHeader from "../category-header/CategoryHeader";
import { adapterCategoryHeader } from "../category-header/category-header.adapter";
import VideosHeader from "../videos-header/videos-header";
import EditionHeader from "../../molecules/EditionHeader/EditionHeader";
import PodcastPlayerHeader from "../../atoms/podcast-player-header/PodcastPlayerHeader";
import PodcastPlayer from "../../molecules/podcast-player/PodcastPlayer";
import HeadboardEditorial from "../headboard-editorial/headboard-editorial";
import HeadboardAticlesPage from "../headboardAticlesPage/headboardAticlesPage";
import Readtime from "../../atoms/readTime/readTime";
import { graphql, useStaticQuery } from "gatsby";

interface LayoutInterface {
  children: any;
  headboard?: ReferenciaCabecera;
  isNotRoot?: boolean;
  hideHeaderDesktop: boolean;
  hideHeaderMobile: boolean;
  showPlayer?: boolean;
  readTime?: number;
}

const Layout = (props: LayoutInterface) => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [isSearcherActive, setSearcherActive] = useState(false);
  const [_scrollActive, setScrollActive] = useState(false);
  const [size, setSize] = useState(0);
  const [_superFooter, setSuperFooter] = useState<boolean>(false);
  const [genreSelected, setGenreSelected] = useState("");
  const [gigyaUid, setGigyaUid] = useState("");
  const [isDark, changeDarkMode] = useChangeTheme();
  const { lastDirection, resetDirection } = useDirectionScroll();
  const { isBrowser, localStorage, document, window } = useBrowserMode();

  
  const idEpisodeQuery = useStaticQuery(graphql`
    query EPISODIO_SPOTIFY {
      allContentfulHome {
        nodes {
          idEpisodioSpotify
        }
      }
    }
  `);

  const idEpisode = idEpisodeQuery.allContentfulHome.nodes[0].idEpisodioSpotify;

  useEffect(() => {
    toLocalStoragepageActive();
    if (isBrowser) {
      const realSize = parseInt(localStorage.getItem("font-size") || "100");
      const item = document.querySelector("html") || {
        style: { fontSize: realSize },
      };
      item.style.fontSize = `${realSize}%`;
      setSize(realSize);
      setCollectionToken(localStorage.getItem("uid") || "", true, true);
      toLocalStoragepageActive();
    }
    isBrowser && document.addEventListener("scroll", onScrollAction);
    return () => {
      isBrowser && document.removeEventListener("scroll", onScrollAction);
    };
  }, []);

  const toLocalStoragepageActive = () => {
    if (localStorage.getItem("Redirection")) {
      const data = JSON.parse(localStorage.getItem("Redirection"));
      if (data.titleButton === "BIBLIOTECAS") {
        return false;
      } else {
        return localStorage.setItem(
          "Redirection",
          JSON.stringify({
            titleButton: "BIBLIOTECAS",
            path: "bibliotecas",
          })
        );
      }
    } else {
      return localStorage.setItem(
        "Redirection",
        JSON.stringify({
          titleButton: "BIBLIOTECAS",
          path: "bibliotecas",
        })
      );
    }
  };

  const doSetSize = (_size: number) => {
    localStorage.setItem("font-size", `${_size}`);
    setSize(_size);
  };

  const scrollActive = { get: _scrollActive, set: setScrollActive };

  const doSetGenre = (genre: string) => setGenreSelected(genre);

  const doSetGigyaUid = (uid: string) => setGigyaUid(uid);

  const context = {
    fontSize: { get: size, set: doSetSize },
    superFooter: { get: _superFooter, set: setSuperFooter },
    genreSelected: { get: genreSelected, set: doSetGenre },
    gigyaUid: { get: gigyaUid, set: doSetGigyaUid },
  };

  let timerScroll: any;

  const onScrollAction = () => {
    return;
    window.clearTimeout(timerScroll);
    timerScroll = setTimeout(() => {
      if (window.pageYOffset < 70) {
        resetDirection();
      }
    }, 66);
  };

  const switchHeadBoard = (headboard: ReferenciaCabecera) => {
    switch (headboard.tipoCabecera) {
      case "CabeceraSimple":
        return <Headboard {...headboard} />;
      case "PageHeader":
        return <HeadboardTwo {...headboard} />;
      case "CategoryHeader":
        return <CategoryHeader {...adapterCategoryHeader(headboard)} />;
      case "VideoHeader":
        return <VideosHeader {...headboard} />;
      case "EditionHeader":
        return <EditionHeader {...headboard} />;
      case "EditorialHeader":
        return <HeadboardEditorial {...headboard} />;
      case "CabeceraPaginaArticulos":
        return <HeadboardAticlesPage {...headboard} />;
      default:
        return <Headboard {...headboard} />;
    }
  };

  return (
    <GlobalContext.Provider value={context}>
      <Header
        isNotRoot={props.isNotRoot}
        scrollActive={scrollActive}
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        setMenuActive={setMenuActive}
        setSearcherActive={setSearcherActive}
        isDark={isDark}
        actionTheme={changeDarkMode}
        lastDirection={lastDirection}
        hideHeaderDesktop={props.hideHeaderDesktop}
        hideHeaderMobile={props.hideHeaderMobile}
      />
      <Nav
        setSearcherActive={setSearcherActive}
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        setMenuActive={setMenuActive}
        isDark={isDark}
        actionTheme={changeDarkMode}
      />
      {props.showPlayer && (
        <PodcastPlayerHeader>
          <PodcastPlayer
            id={idEpisode}
            className="header"
            height={80}
          />
        </PodcastPlayerHeader>
      )}
      <div>
        {props.headboard && switchHeadBoard(props.headboard)}
        <main>
          {props.readTime && (<Readtime time={props.readTime} />)}
          {props.children}
        </main>
      </div>
      <Footer isSuperFooter={_superFooter} />
    </GlobalContext.Provider>
  );
};

export default Layout;
